export const CORE_SELF_SERVE_NAME = "core-self-serve";

export enum CoreSelfServeComponent {
  AgentImpersonation = "AgentImpersonation",
  ContactSupportChatFab = "ContactSupportChatFab",
  ContactSupportModalContent = "ContactSupportModalContent",
  ResendEmailModal = "ResendEmailModal",
  SupportChatButton = "SupportChatButton",
}
